import React, { useState } from 'react'
import StockScreenerTable from '../components/StockScreenerTable'
import StockScreenerFilters from '../components/StockScreenerFilters'
import AIChatSidebar from '../components/chat/AIChatSidebar'

const StockScreenerPage = () => {
  const [filters, setFilters] = useState([])
  const [availableFields, setAvailableFields] = useState([
    { key: 'sector', label: 'Sector', type: 'categorical' },
    { key: 'industry', label: 'Industry', type: 'categorical' },
    { key: 'close_price', label: 'Close Price', type: 'numerical' },
    { key: 'revenue', label: 'Revenue', type: 'numerical' },
    { key: 'pe_ratio', label: 'P/E', type: 'numerical' },
  ])

  return (
    <div className="flex h-full bg-gray-50 overflow-hidden">
      {/* Screener Area */}
      <div className="flex-1 min-w-0 flex flex-col bg-white">
        <div className="h-full relative overflow-y-auto custom-scrollbar">
          <div className="px-4 pt-4">
            <StockScreenerFilters
              fields={availableFields}
              filters={filters}
              onChange={setFilters}
              onClear={() => setFilters([])}
            />
          </div>
          <StockScreenerTable
            externalFilters={filters}
            onFieldsReady={(fields) => setAvailableFields(fields)}
          />
        </div>
      </div>

      {/* AI Chat Sidebar */}
      <div className="w-96 flex-shrink-0">
        <AIChatSidebar
          mode="screener"
          placeholder="Find stocks, generate filters, or analyze the table..."
          onApplyFilters={(newFilters) => setFilters(newFilters)}
        />
      </div>
    </div>
  )
}

export default StockScreenerPage
